"use client";

import { Flex, Skeleton, Typography } from "antd";
import React from "react";
import { FaStar } from "react-icons/fa";

const { Paragraph } = Typography;

export type CenterBranchItemDisplayMode = "grid" | "list";

type Props = {
  displayMode?: CenterBranchItemDisplayMode;
};

function ImageBlock({ height }: { height: number }) {
  // این دقیقا نقش SmartImage رو بازی می‌کنه
  return (
    <div
      style={{
        width: "100%",
        height,
        background: "rgba(255,255,255,0.06)",
      }}
    />
  );
}

const CenterBranchItemSkeleton: React.FC<Props> = ({
  displayMode = "grid",
}) => {
  const isGrid = displayMode === "grid";

  if (isGrid) {
    return (
      <div className="card">
        <div className="card-img card-img-hover position-relative">
          <ImageBlock height={195} />

          <div className="grid-overlay-item d-flex align-items-center justify-content-between">
            <div>
              <span
                className="badge bg-orange"
                style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
              >
                <FaStar className="me-1" />
                <Skeleton.Input
                  active
                  size="small"
                  style={{ width: 26, height: 16 }}
                />
              </span>
            </div>

            <span className="fav-icon">
              <Skeleton.Avatar active size={28} shape="circle" />
            </span>
          </div>
        </div>

        <div className="card-body p-0">
          <Flex
            align="center"
            justify="space-between"
            gap={8}
            className="active-bar p-3"
          >
            <Skeleton.Input
              active
              size="small"
              style={{ width: 160, height: 16 }}
            />
            <div
              style={{ width: 25, display: "flex", justifyContent: "flex-end" }}
            >
              <Skeleton.Avatar active size={18} shape="circle" />
            </div>
          </Flex>

          <div className="p-3 pt-0">
            <div className="doctor-info-detail mb-3 pb-3">
              <h3 className="mb-1">
                <Skeleton.Input
                  active
                  size="default"
                  style={{ width: 170, height: 22 }}
                />
              </h3>

              <div className="d-flex align-items-center" style={{ gap: 8 }}>
                {/* CenterBranchTag */}
                <Skeleton.Button
                  active
                  size="small"
                  style={{ width: 110, height: 22 }}
                />

                {/* BriefDescription */}
                <Paragraph style={{ margin: 0, flex: 1 }}>
                  <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 2, width: ["90%", "70%"] }}
                  />
                </Paragraph>
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-between">
              <div style={{ flex: 1, minWidth: 0 }}>
                <Paragraph style={{ margin: 0 }}>
                  <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 2, width: ["85%", "55%"] }}
                  />
                </Paragraph>
              </div>

              <div style={{ marginInlineStart: 12 }}>
                <Skeleton.Button
                  active
                  size="small"
                  style={{ width: 120, height: 36, borderRadius: 999 }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // LIST
  return (
    <div className="card doctor-list-card">
      <div className="d-md-flex align-items-center">
        <div className="card-img card-img-hover position-relative">
          <div style={{ width: 300 }}>
            <ImageBlock height={253} />
          </div>

          <div className="grid-overlay-item d-flex align-items-center justify-content-between">
            <div>
              <span
                className="badge bg-orange"
                style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
              >
                <FaStar className="me-1" />
                <Skeleton.Input
                  active
                  size="small"
                  style={{ width: 26, height: 16 }}
                />
              </span>
            </div>

            <span className="fav-icon">
              <Skeleton.Avatar active size={28} shape="circle" />
            </span>
          </div>
        </div>

        <div className="card-body p-0" style={{ flex: 1 }}>
          <Flex
            align="center"
            justify="space-between"
            gap={8}
            className="border-bottom p-3"
          >
            <Skeleton.Input
              active
              size="small"
              style={{ width: 280, height: 16 }}
            />
            <div
              style={{ width: 25, display: "flex", justifyContent: "flex-end" }}
            >
              <Skeleton.Avatar active size={18} shape="circle" />
            </div>
          </Flex>

          <div className="p-3">
            <div className="doctor-info-detail pb-3">
              <div className="row align-items-center gy-3">
                <div className="col-sm-6">
                  <h6 className="d-flex align-items-center mb-1">
                    <Skeleton.Input
                      active
                      size="default"
                      style={{ width: 220, height: 20 }}
                    />
                  </h6>
                  <Skeleton.Input
                    active
                    size="small"
                    style={{ width: 280, height: 14 }}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mt-3">
              <div style={{ width: 320, maxWidth: "100%" }}>
                <Skeleton
                  active
                  title={false}
                  paragraph={{ rows: 2, width: ["90%", "70%"] }}
                />
              </div>

              <Skeleton.Button
                active
                size="small"
                style={{ width: 140, height: 38, borderRadius: 999 }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CenterBranchItemSkeleton;
